import { input, Component, booleanAttribute, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import {
  CdkTable,
  CDK_TABLE,
  DataRowOutlet,
  FooterRowOutlet,
  HeaderRowOutlet,
  NoDataRowOutlet,
  STICKY_POSITIONING_LISTENER,
} from '@angular/cdk/table';

@Component({
  selector: 'app-table, table[appTable]',
  exportAs: 'appTable',
  templateUrl: './table.html',
  styleUrl: './table.scss',
  imports: [DataRowOutlet, FooterRowOutlet, HeaderRowOutlet, NoDataRowOutlet],
  providers: [
    { provide: CdkTable, useExisting: Table },
    { provide: CDK_TABLE, useExisting: Table },
    { provide: STICKY_POSITIONING_LISTENER, useValue: null },
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'app-table',
    '[class.app-table_clickable]': 'clickable()',
  },
})
export class Table<T> extends CdkTable<T> {
  public readonly loading = input(false, { transform: booleanAttribute });
  public readonly clickable = input(false, { transform: booleanAttribute });

  public readonly emptyMessage = input<string>('shared.ui.table.empty');

  protected override stickyCssClass = 'app-table-sticky';
  protected override needsPositionStickyOnElement = false;
}
